import {ActionTree} from "vuex";
import {TriggerImplementationState, TriggerImplementation} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";
import Qs from "qs";

const actions: ActionTree<TriggerImplementationState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    const paramsHash = {
      params: params,
      paramsSerializer: function (params: object) {
        return Qs.stringify(params, { arrayFormat: 'brackets' })
      }
    }

    return rootGetters['hcs/client'].get('/trigger_implementations', paramsHash)
        .then((response: AxiosResponse) => {
          const triggerImplementations: TriggerImplementation[] = response.data;
          commit('setTriggerImplementations', triggerImplementations);
          return triggerImplementations;
        });
  },
  createMulti({rootGetters, commit}, params) {
    let promises: any = [];

    params.eventImplementationIds.forEach((id: string) => {
      promises.push(
        rootGetters['hcs/client'].post('/trigger_implementations', { eventImplementationId: id, processImplementationId: params.processImplementationId })
      )
    })

    params.calendarIds.forEach((id: string) => {
      promises.push(
        rootGetters['hcs/client'].post('/trigger_implementations', { calendarId: id, processImplementationId: params.processImplementationId })
      )
    })

    return Promise.all(promises)
        .then((response: any) => {
          const datas = response.map((r: AxiosResponse) => r.data);
          datas.forEach((triggerImplementation: any) => {
            commit('addTriggerImplementation', triggerImplementation);
          });
          return datas;
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/trigger_implementations/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteTriggerImplementation', id);
        });
  }
}

export default actions;
